import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    AlertTitle,
    Card,
    CardContent,
    Grid,
    Paper,
    Breadcrumbs,
    Link as MuiLink,
    Avatar,
    Divider,
    CircularProgress
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import SendIcon from '@mui/icons-material/Send';
import BlockIcon from '@mui/icons-material/Block';
import { isAuthenticated } from "../auth";
import { singleGroup, groupDetails } from "./apigroup";
import { sendMessage } from "../user/apiUser";
import { Link } from "react-router-dom";
import Footer from '../core/Footer';

class GroupAccess extends Component {

    state = {
        groupId: this.props.match.params.groupId,
        group: '',
        groupName: '',
        redirectToHome: false,
        redirectToSignin: false,
        chair: '',
        cochair: '',
        chairEmail: '',
        cochairEmail: '',
        message: '',
        success: false,
        error: '',
        loading: false,
        allowedAccess: false
    };

    handleChange = name => event => {
        let value = event.target.value;
        this.setState({ [name]: value });
    };

    validateMembership = (group) => {
        switch (group) {
            case '5e5591a97ff73f6d34835a05': // leadership
                return false;
            case '65ce5e76e54fd763dfc9c0ae': // content
                return false;
            default:
                return true;
        }
    };

    componentDidMount = () => {
        singleGroup(this.state.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    group: data,
                    message: '',
                    success: false
                });
            }
        });

        groupDetails(this.state.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({
                    groupName: data.name || '',
                    chair: data.chair ? data.chair.name : '',
                    chairLastName: data.chair ? data.chair.lastName : '',
                    chairCompany: data.chair ? data.chair.companyName : '',
                    cochair: data.cochair ? data.cochair.name : '',
                    cochairLastName: data.cochair ? data.cochair.lastName : '',
                    cochairCompanyName: data.cochair ? data.cochair.companyName : '',
                    chairEmail: data.chair ? data.chair.email : '',
                    cochairEmail: data.cochair ? data.cochair.email : '',
                });
            }
        });

        this.setState({
            user: isAuthenticated(),
            allowedAccess: this.validateMembership(this.state.groupId)
        });
    };

    sendMessage = async (e) => {
        e.preventDefault();

        console.log("Send Access Request clicked");

        // Set loading state
        this.setState({
            loading: true,
            success: false,
            error: ''
        });

        const user = isAuthenticated();

        // Check if user is authenticated
        if (!user) {
            this.setState({
                loading: false,
                error: 'You must be signed in to request access. Please sign in and try again.'
            });
            return;
        }

        // isAuthenticated() returns {name, email, ...} directly, not nested under .user
        const userName = user.name || 'User';
        const userEmail = user.email || '';
        const chairName = this.state.chair || 'Committee Chair';

        console.log("User info:", { userName, userEmail });
        console.log("Chair info:", { chairName, chairEmail: this.state.chairEmail });

        // Use the same format as Signup.js - flat object, no "body" wrapper
        const result = await sendMessage({
            subject: "Requesting access to the " + this.state.groupName,
            from: "donotreply@sdsconsortium.com",
            to: this.state.chairEmail,
            bcc: [this.state.cochairEmail],
            text: `Access request for ${this.state.groupName} from ${userName} (${userEmail}). ${this.state.message ? 'Message: ' + this.state.message : ''}`,
            html: `<html><body>
                <p>Message from the SDSIC site,</p>
                <p><strong>From user:</strong> ${userName} (email: ${userEmail})</p>
                <p><strong>Request:</strong> Please grant me access to the ${this.state.groupName}</p>
                ${this.state.message ? `<p><strong>Additional Message:</strong> ${this.state.message}</p>` : ''}
                <br/>
                <p>Copy and paste this URL into your web browser to access the admin page for the group:</p>
                <p><a href="https://sdsconsortium.com/admin/committee/${this.props.match.params.groupId}">https://sdsconsortium.com/admin/committee/${this.props.match.params.groupId}</a></p>
                </body></html>`
        });

        // Only report success once the server confirms the email actually sent.
        if (!result || result.error) {
            this.setState({
                loading: false,
                success: false,
                error: (result && result.error) || 'Your request could not be sent. Please try again.'
            });
            return;
        }

        this.setState({
            loading: false,
            message: '',
            success: true,
            error: ''
        });
    };

    render() {
        const { group, chair, chairLastName, chairCompany, cochair, cochairLastName, cochairCompanyName } = this.state;

        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 5, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Breadcrumbs
                            separator={<NavigateNextIcon fontSize="small" />}
                            sx={{
                                mb: 3,
                                '& .MuiBreadcrumbs-separator, & a, & p': { color: 'rgba(255, 255, 255, 0.7)' }
                            }}
                        >
                            <MuiLink component={Link} to="/usershome" underline="hover">
                                Home
                            </MuiLink>
                            <MuiLink component={Link} to="/grouplist" underline="hover">
                                Committees
                            </MuiLink>
                            <Typography sx={{ color: 'white !important' }}>Access Request</Typography>
                        </Breadcrumbs>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            {this.state.allowedAccess ? (
                                <LockOpenIcon sx={{ fontSize: 56 }} />
                            ) : (
                                <BlockIcon sx={{ fontSize: 56 }} />
                            )}
                            <Box>
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 600 }}>
                                    {this.state.allowedAccess ? 'Request Committee Access' : 'Access Restricted'}
                                </Typography>
                                <Typography variant="h6" sx={{ opacity: 0.9 }}>
                                    {group && group.name ? group.name : this.state.groupName}
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>

                <Container maxWidth="md" sx={{ mb: 6 }}>
                    {this.state.allowedAccess ? (
                        <>
                            {/* Success Alert */}
                            {this.state.success && (
                                <Alert severity="success" sx={{ mb: 3, fontSize: '1rem' }} variant="filled">
                                    <AlertTitle sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                                        Message Sent Successfully!
                                    </AlertTitle>
                                    You should hear back from {chair} {chairLastName} shortly.
                                </Alert>
                            )}

                            {/* Error Alert */}
                            {this.state.error && (
                                <Alert severity="error" sx={{ mb: 3, fontSize: '1rem' }} variant="filled">
                                    <AlertTitle sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
                                        Error Sending Request
                                    </AlertTitle>
                                    {this.state.error}
                                </Alert>
                            )}

                            {/* Committee Leadership Cards */}
                            <Grid container spacing={3} sx={{ mb: 4 }}>
                                {/* Chair Card */}
                                <Grid item xs={12} md={6}>
                                    <Card elevation={3} sx={{ borderRadius: 3, height: '100%' }}>
                                        <Box sx={{ backgroundColor: '#FF6600', color: 'white', p: 2 }}>
                                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                Committee Chair
                                            </Typography>
                                        </Box>
                                        <CardContent sx={{ p: 3 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                                <Avatar sx={{ width: 48, height: 48, backgroundColor: '#FF6600' }}>
                                                    {chair && chair.charAt(0)}{chairLastName && chairLastName.charAt(0)}
                                                </Avatar>
                                                <Box>
                                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                        {chair} {chairLastName}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Divider sx={{ mb: 2 }} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                <BusinessIcon sx={{ fontSize: 18, color: '#666' }} />
                                                <Typography variant="body2" color="text.secondary">
                                                    {chairCompany}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <EmailIcon sx={{ fontSize: 18, color: '#666' }} />
                                                <Typography variant="body2" color="text.secondary">
                                                    {this.state.chairEmail}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* Co-Chair Card */}
                                <Grid item xs={12} md={6}>
                                    <Card elevation={3} sx={{ borderRadius: 3, height: '100%' }}>
                                        <Box sx={{ backgroundColor: '#4caf50', color: 'white', p: 2 }}>
                                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                Committee Co-Chair
                                            </Typography>
                                        </Box>
                                        <CardContent sx={{ p: 3 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                                <Avatar sx={{ width: 48, height: 48, backgroundColor: '#4caf50' }}>
                                                    {cochair && cochair.charAt(0)}{cochairLastName && cochairLastName.charAt(0)}
                                                </Avatar>
                                                <Box>
                                                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                        {cochair} {cochairLastName}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Divider sx={{ mb: 2 }} />
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                                <BusinessIcon sx={{ fontSize: 18, color: '#666' }} />
                                                <Typography variant="body2" color="text.secondary">
                                                    {cochairCompanyName}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <EmailIcon sx={{ fontSize: 18, color: '#666' }} />
                                                <Typography variant="body2" color="text.secondary">
                                                    {this.state.cochairEmail}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* Request Form */}
                            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                                <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E', mb: 3 }}>
                                    Send Access Request
                                </Typography>

                                <Box component="form" onSubmit={this.sendMessage}>
                                    <TextField
                                        fullWidth
                                        label="To (Committee Chair)"
                                        value={this.state.chairEmail}
                                        disabled
                                        margin="normal"
                                        variant="outlined"
                                    />

                                    <TextField
                                        fullWidth
                                        label="Subject"
                                        value={`Requesting access to the ${this.state.groupName}`}
                                        disabled
                                        margin="normal"
                                        variant="outlined"
                                    />

                                    <TextField
                                        fullWidth
                                        label="Your Message (Optional)"
                                        multiline
                                        rows={6}
                                        value={this.state.message}
                                        onChange={this.handleChange('message')}
                                        margin="normal"
                                        variant="outlined"
                                        placeholder="Add any additional information to help the committee chair understand your request..."
                                    />

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        size="large"
                                        disabled={this.state.loading}
                                        startIcon={this.state.loading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                                        fullWidth
                                        sx={{
                                            mt: 3,
                                            backgroundColor: '#FF6600',
                                            py: 1.5,
                                            '&:hover': {
                                                backgroundColor: '#e55a00'
                                            },
                                            '&:disabled': {
                                                backgroundColor: '#ccc'
                                            }
                                        }}
                                    >
                                        {this.state.loading ? 'Sending...' : 'Send Access Request'}
                                    </Button>
                                </Box>
                            </Paper>
                        </>
                    ) : (
                        // Access Not Allowed
                        <Card elevation={3} sx={{ borderRadius: 3, border: '2px solid #f44336' }}>
                            <Box sx={{ backgroundColor: '#f44336', color: 'white', p: 3 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <BlockIcon sx={{ fontSize: 40 }} />
                                    <Typography variant="h5" sx={{ fontWeight: 600 }}>
                                        Access Request Not Available
                                    </Typography>
                                </Box>
                            </Box>
                            <CardContent sx={{ p: 4 }}>
                                <Alert severity="warning" sx={{ mb: 3 }}>
                                    You cannot request access to the <strong>{this.state.groupName}</strong> through the automated system.
                                </Alert>

                                <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
                                    If you believe you should have access to this committee, please contact the committee chair directly:
                                </Typography>

                                <Paper elevation={2} sx={{ p: 3, backgroundColor: 'rgba(0, 62, 126, 0.05)' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                        <Avatar sx={{ width: 48, height: 48, backgroundColor: '#003E7E' }}>
                                            <PersonIcon />
                                        </Avatar>
                                        <Box>
                                            <Typography variant="subtitle2" color="text.secondary">
                                                Committee Chair
                                            </Typography>
                                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                {this.state.chair} {this.state.chairLastName}
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Button
                                        href={`mailto:${this.state.chairEmail}`}
                                        variant="contained"
                                        startIcon={<EmailIcon />}
                                        fullWidth
                                        sx={{
                                            backgroundColor: '#003E7E',
                                            '&:hover': {
                                                backgroundColor: '#00325a'
                                            }
                                        }}
                                    >
                                        Email {this.state.chair}
                                    </Button>
                                </Paper>

                                <Box sx={{ mt: 3, textAlign: 'center' }}>
                                    <Button
                                        component={Link}
                                        to="/grouplist"
                                        variant="outlined"
                                        sx={{
                                            borderColor: '#003E7E',
                                            color: '#003E7E',
                                            '&:hover': {
                                                borderColor: '#003E7E',
                                                backgroundColor: 'rgba(0, 62, 126, 0.1)'
                                            }
                                        }}
                                    >
                                        Back to Committee List
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    )}
                </Container>

                <Footer />
            </>
        );
    }
}

export default GroupAccess;